import { Reveal, Slug } from "./Motion";

const Block = ({ b }) =>
  b.pull ? (
    <Reveal>
      <p className="my-14 border-l-2 border-[#C81D25] pl-6 font-display text-3xl font-bold leading-tight text-[#E2E0D8] sm:text-4xl lg:text-5xl">
        {b.pull}
      </p>
    </Reveal>
  ) : (
    <Reveal>
      <p className="text-base leading-[1.85] text-[#C3CAD5] md:text-lg">{b.p}</p>
    </Reveal>
  );

export const Chapter = ({ c }) => (
  <article className="border-t border-white/10 px-5 py-24 md:px-10 md:py-32" data-testid={`synopsis-chapter-${c.num.toLowerCase()}`}>
    <div className="mx-auto grid max-w-[1400px] gap-12 lg:grid-cols-[4fr_7fr]">
      <div className="lg:sticky lg:top-28 lg:self-start">
        <Reveal>
          <Slug>{c.slug}</Slug>
          <div className="mt-6 flex items-end gap-5">
            <span className="font-display text-8xl font-extrabold leading-none text-outline md:text-9xl">{c.num}</span>
            <span className="font-display text-3xl text-[#C81D25] md:text-4xl">{c.kanji}</span>
          </div>
          <h3 className="mt-6 font-serif-i text-4xl text-[#E2E0D8] md:text-5xl">{c.title}</h3>
        </Reveal>
      </div>
      <div className="space-y-6">
        {c.blocks.map((b, i) => <Block key={i} b={b} />)}
      </div>
    </div>
  </article>
);
